module.exports = __webpack_public_path__ + "static/media/pointer.5d105415.png";